import { gql } from '@apollo/client';
import { AccountType } from 'graphql/types/AccountType';

export const GET_ACCOUNT_LISTING_WITH_FILTERS = gql`
    query GetAccountListingWithFilters($filters: AccountFiltersInput!) {
        getAccountListingWithFilters(filters: $filters) {
            id
            name
            countryCode
            phone
            email
            status
            role {
                name
            }
            createdAt
            updatedAt
        }
    }
`;

export interface AccountFiltersInput {
    role?: string;
    id?: string;
    name?: string;
    phone?: string;
    status?: number;
}

export interface GetAccountListingWithFiltersResponse {
    getAccountListingWithFilters: AccountType[];
}
